module.exports = __webpack_public_path__ + "img/cal-pre-mobile-small-fa.3645cc60.png";